import { styled } from '@mui/system'
import Typography from '@/ui/components/typography'
import { TTheme } from '@/core/theme'

export const TabsContainer = styled('div')<{ theme?: TTheme }>`
    display: flex;
    align-content: center;
    align-items: center;
    margin-top: 24px;
    flex: 1;

    .Mui-selected {
        font-weight: bold;
    }

    .MuiTabs-indicator {
        background-color: ${({ theme }) => theme?.colors.greys[700]} !important;
    }

    .MuiTabs-root {
        border-bottom: 1px solid ${({ theme }) => theme?.colors.greys[200]};
    }

    .MuiButtonBase-root {
        font-size: 1.6rem;
        line-height: 20px;
        display: block;
        text-transform: none;

        :hover {
            cursor: pointer;
        }
    }
`

export const TabsRoutingContainer = styled('div')<{ theme?: TTheme }>`
    display: flex;
    margin-top: 24px;
    flex: 1;
`

export const FlexAll = styled('div')`
    flex: 1;
`

export const TabsRoutingTabLabel = styled(Typography)<{
    active: boolean
    activeColor: string
    inactiveColor: string
}>`
    color: ${({ active, activeColor, inactiveColor }) =>
        active ? activeColor : inactiveColor};
`

